<ion-header>
  <ion-toolbar mode="ios" color="primary">
    <ion-buttons slot="start">
      <ion-menu-button />
    </ion-buttons>
    <ion-title><img src="./images/climars-logo.png" alt="" /></ion-title>
  </ion-toolbar>
</ion-header>
